<template>
  <div>
    <b-row>
      <b-col>

        <b-form-group class="">
          <label for="" style="font-size: small;" class="mb-1">
            ¿Ha experimentado alguno de los siguientes síntomas? (Seleccione todos los que apliquen)
          </label>

          <v-select
            class="mb-2"
            placeholder="Seleccione una o mas opciones"
            :options="sintomasOpts"
            :reduce="option => option"
            label="text"
            :multiple="true"
            taggable
            @input="newArray => sintomasVSelect = onAddNewOpt(newArray)"
          />

        </b-form-group>

        <b-card
          v-for="( sintoma ) in preguntas.sintomas"
          :key="sintoma.value"
          class="mb-2"
          style="border:1px solid #c9c9c9;"
        >
          <b-row>
            <b-col>
              <h6>{{ sintoma.text }}</h6>
            </b-col>
          </b-row>

          <b-row class="my-1 d-flex align-items-center">
            <label class="col-3">Comienzo</label>

            <b-form-input 
              class="col-2 ml-1"
              type="number"
              min="0"
              max="99"
              v-model="sintoma.comienzoNumero"
            />

            <v-select
              class="col-4"
              placeholder="Desde cuando"
              :options="tipoTiempoOpts"
              :reduce="option => option"
              label="text"
              v-model="sintoma.comienzoTipo"
            />
          </b-row>

          <b-row class="my-1 d-flex align-items-center">
            <label class="col-3">Factores de riesgo</label>
            <v-select
              class="col-8"
              placeholder="Factores de riesgo"
              :options="factoresOpts"
              :reduce="option => option"
              label="text"
              :multiple="true"
              taggable
              @input="newArray => sintoma.factores = onAddNewOpt(newArray)"
            />
          </b-row>

          <b-row class="my-1 d-flex align-items-center">
            <label class="col-3">Tratamientos</label>
            <v-select
              class="col-8"
              placeholder="Factores de riesgo"
              :options="tratamientosOpts"
              :reduce="option => option"
              label="text"
              :multiple="true"
              taggable
              @input="newArray => sintoma.tratamientos = onAddNewOpt(newArray)"
            />
          </b-row>
          
        </b-card>

        <div>
          <b-form-checkbox
            v-model="preguntas.observaciones.active"
          >
            <label for="">Observaciones Adicionales:</label>
          </b-form-checkbox>

          <b-form-textarea
            v-if="preguntas.observaciones.active"
            v-model="preguntas.observaciones.text"
          />
        </div>

      </b-col>
    </b-row>
  </div>
</template>

<script>

import vSelect from "vue-select";
import { addNewOpt } from '@/shared/helpers';


export default {
  name: "OncologiaPreguntas",

  components: {
    vSelect
  },

  data() {
    return {

      sintomasVSelect: [],

      preguntas: {
        sintomas: [],
        observaciones:{
          active: false,
          text: ''
        },
      },

      sintomasOpts: [
        { value: "perdidaPeso",           text: "Pérdida de peso inexplicada" },
        { value: "fatigaPersiste",        text: "Fatiga persistente" },
        { value: "dolorConstante",        text: "Dolor constante o intermitente" },
        { value: "bultos",                text: "Bultos o masas palpables" },
        { value: "cambiosPiel",           text: "Cambios en la piel (color, tamaño, forma de lunares)" },
        { value: "cambioshabitos",        text: "Cambios en los hábitos intestinales o urinarios" },
        { value: "tos",                   text: "Tos persistente o dificultad para respirar" },
        { value: "dificultadTragar",      text: "Dificultad para tragar" },
        { value: "sangrado",              text: "Sangrado o secreciones inusuales" },
        { value: "nodulares",             text: "Nodulares" },
        { value: "macrocalcificaciones",  text: "Macrocalcificaciones" },
        { value: "retraccionPiel",        text: "Retracción de piel o pezón" },
        { value: "masasQuisticas",        text: "Masas quísticas" }
      ],

      tipoTiempoOpts:[
        { value: 'dias',    text: 'Dias' },
        { value: 'semanas', text: 'Semanas' },
        { value: 'meses',   text: 'Meses' },
        { value: 'anios',   text: 'Años' },
      ],

      factoresOpts : [
        { value: "tabaquismo",           text: "Tabaquismo" },
        { value: "exceso_alcohol",       text: "Consumo excesivo de alcohol" },
        { value: "sustancias_quimica",   text: "Exposición a sustancias químicas (asbesto, benceno, etc.)" },
        { value: "radiacion",            text: "Radiación" },
        { value: "infecciones_virales",  text: "Infecciones virales (VPH, hepatitis B o C, VIH)" },
        { value: "dieta_poco_saludable", text: "Dieta poco saludable" },
        { value: "sedentarismo",         text: "Sedentarismo" }
      ],

      tratamientosOpts : [
        { value: "quimioterapia",    text: "Quimioterapia" },
        { value: "radioterapia",     text: "Radioterapia" },
        { value: "cirugia",          text: "Cirugía" },
        { value: "terapia_hormonal", text: "Terapia hormonal" },
        { value: "inmunoterapia",    text: "Inmunoterapia" }
      ],

      isVisibleOncologiaComienzo:false,
      isVisibleOncologiaFactores:false,
      isVisibleOncologiaTratamientos:false
    }
  },

  methods: {

    onAddNewOpt(newArray) {
      return addNewOpt(newArray);
    },

  },

  watch: {

    sintomasVSelect:{
      deep:true,
      handler( newArray ){
        const idSintomas = this.sintomasVSelect.map( item => item.value );

        this.preguntas.sintomas = this.preguntas.sintomas.filter(
          item => idSintomas.includes(item.value)
        );

        idSintomas.forEach( id => {
          if( !this.preguntas.sintomas.some( item => item.value === id )){
            const newItem = newArray.find( item => item.value === id );

            this.preguntas.sintomas.push({
              id: newItem.id || null,
              value: newItem.value,
              text: newItem.text,
              comienzoTipo: null,
              comienzoNumero: null,
              factores:[],
              tratamientos:[]
            });
          }
        });
      }
    },

    preguntas: {
      deep: true,
      handler(newValue){
        console.log(newValue);
        this.$store.commit("setOncologicaPreguntas", newValue);
      }
    }
  },
}
</script>

<style>

</style>